import { render, staticRenderFns } from "./video-handout.vue?vue&type=template&id=b08097f6&scoped=true"
import script from "./video-handout.vue?vue&type=script&lang=js"
export * from "./video-handout.vue?vue&type=script&lang=js"
import style0 from "./video-handout.vue?vue&type=style&index=0&id=b08097f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08097f6",
  null
  
)

export default component.exports